module.exports = __webpack_public_path__ + "img/clipboard.c136da54.png";